import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import axios from 'axios';
import { defaultRealms } from '@/foundations/helpers/defaultRealms';

type Props = {
  title: string;
  resource: unknown;
};

interface Settings {
  realm: string;
  display: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  resource: unknown;
}



const settings = ref<Settings[]>([]);
const headers = [
  { text: 'Realm', value: 'realm' },
  { text: 'Display reading competition', value: 'display' },
  { text: '', value: 'remove' },
];

const showAddSettings = ref<boolean>(false);
const realm = ref<string>('');
const display = ref<boolean>(true);
const listOfRealm = ref();

const getSettings = async () => {
  const settingsResponse = await axios.get(`${process.env.VUE_APP_COMPETITION_REFEREE_API_URL}competitions/settings`);

  settings.value = settingsResponse.data as Settings[];
};

const updateSettings = async (setting: Settings) => {
  await axios.put(`${process.env.VUE_APP_COMPETITION_REFEREE_API_URL}competitions/settings/${setting.realm}`, {
    display: setting.display,
  });
};

const removeSettings = async (setting: Settings) => {
  await axios.delete(`${process.env.VUE_APP_COMPETITION_REFEREE_API_URL}competitions/settings/${setting.realm}`);
  getSettings();
};
const createSettings = async () => {
  showAddSettings.value = true;
  listOfRealm.value = defaultRealms
    .filter((r) => !settings.value.some((s) => s.realm === r.code))
    .map((country) => country.code);
};

const addSettings = async () => {
  await axios.post(`${process.env.VUE_APP_COMPETITION_REFEREE_API_URL}competitions/settings`, {
    realm: realm.value,
    display: display.value,
  });
  getSettings();
  showAddSettings.value = false;
};

getSettings();

const fields = [
  {
    source: 'id',
    sortable: false,
    link: 'edit',
  },
  {
    source: 'realm',
    sortable: true,
  },
  {
    source: 'name',
    sortable: true,
    link: 'edit',
  },
];

const filters = [];

return { __sfc: true,props, settings, headers, showAddSettings, realm, display, listOfRealm, getSettings, updateSettings, removeSettings, createSettings, addSettings, fields, filters }
}

})